import React from 'react';
import styles from './PointLayout.module.scss';
import Sidebar from '../../Point/Sidebar/Sidebar';

const PointLayout = props => {
    return (
        <div className={styles.point}>
            <div className={styles.sidebar}>
                <Sidebar />
            </div>
            <div className={styles.content}>{props.children}</div>
        </div>
    );
};

export default PointLayout;
